import styled from 'styled-components';

export const Section02_Styled = styled.section`
  padding: 32px 0 60px;
  background-color: #e2e6e8;
  overflow: hidden;
  position: relative;
  text-align: center;

  @media screen and (min-width: 992px) {
    padding: 80px 0 100px;
    text-align: left;
  }
`;

export const Title = styled.h2`
  font-size: 20px;
  position: relative;
  z-index: 10;

  @media screen and (min-width: 992px) {
    font-size: 30px;
    grid-column: 2 / 7;
  }
`;

export const Description = styled.p`
  font-size: 16px;
  position: relative;
  z-index: 10;
  margin-bottom: 295px;

  @media screen and (min-width: 480px) {
    margin-bottom: 325px;
    padding-right: 0;
  }

  @media screen and (min-width: 992px) {
    font-size: 18px;
    line-height: 30px;
    color: #4f4f4f;
    grid-column: 2 / 7;
    padding-right: 50px;
    margin-bottom: 35px;
  }
`;

export const Action = styled.a`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 500;
  text-transform: uppercase;
  position: relative;
  z-index: 10;

  &:hover {
    opacity: 0.8;
    cursor: pointer;

    &:after {
      opacity: 0.8;
    }
  }

  &:after {
    content: '';
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 10px;
    border-top: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-left: 5px solid #000000;
  }

  @media screen and (min-width: 992px) {
    grid-column: 2 / 7;
  }
`;

export const Image = styled.div`
  position: absolute;
  left: 50%;
  top: 68px;
  transform: translate(-70%, 0);
  z-index: 0;
  width: 400px;
  z-index: 9;

  @media screen and (min-width: 480px) {
    top: 40px;
  }

  @media screen and (min-width: 992px) {
    top: 50%;
    transform: translate(-150px, -50%);
    width: auto;
  }

  img {
    width: 140%;

    @media screen and (min-width: 992px) {
      width: auto;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Section-02/styled.js